export const CARD_W = 200;
const GAP = 16;
const INDENT = 22;

const isStack = (n, kids) => {
  const ch = kids[n.id] || [];
  return ch.length > 0 && (n.stack || (n.kind === "team" && ch.length > 1 && ch.every((c) => !(kids[c.id] || []).length)));
};

function merge(into, from, dx, dd) {
  Object.entries(from).forEach(([d, [a, b]]) => {
    const k = +d + dd;
    const cur = into[k];
    into[k] = cur ? [Math.min(cur[0], a + dx), Math.max(cur[1], b + dx)] : [a + dx, b + dx];
  });
}

function stackList(list, kids, depth, left, out) {
  let d = depth;
  list.forEach((c) => {
    out.nodes.push({ n: c, x: left + CARD_W / 2, d });
    merge(out.contour, { [d]: [left, left + CARD_W] }, 0, 0);
    out.items.push({ d, left });
    const ch = kids[c.id] || [];
    d += 1;
    if (ch.length) {
      const sub = { lineX: left + INDENT - 10, fromD: d - 1, fromX: left + INDENT - 10, items: [] };
      out.stacks.push(sub);
      const inner = { nodes: out.nodes, contour: out.contour, items: sub.items, stacks: out.stacks };
      d = stackList(ch, kids, d, left + INDENT, inner);
    }
  });
  return d;
}

function layout(n, kids) {
  const res = { nodes: [{ n, x: 0, d: 0 }], edges: [], stacks: [], contour: { 0: [-CARD_W / 2, CARD_W / 2] } };
  const ch = kids[n.id] || [];
  if (!ch.length) return res;
  if (isStack(n, kids)) {
    const left = -CARD_W / 2 + INDENT;
    const st = { lineX: left - 10, fromD: 0, fromX: 0, items: [] };
    res.stacks.push(st);
    stackList(ch, kids, 1, left, { nodes: res.nodes, contour: res.contour, items: st.items, stacks: res.stacks });
    return res;
  }
  const subs = ch.map((c) => layout(c, kids));
  const acc = {};
  const xs = subs.map((s, i) => {
    if (i === 0) { merge(acc, s.contour, 0, 0); return 0; }
    let off = -Infinity;
    Object.entries(s.contour).forEach(([d, [a]]) => { if (acc[d]) off = Math.max(off, acc[d][1] - a + GAP); });
    if (off === -Infinity) off = 0;
    merge(acc, s.contour, off, 0);
    return off;
  });
  const mid = (xs[0] + xs[xs.length - 1]) / 2;
  subs.forEach((s, i) => {
    const dx = xs[i] - mid;
    s.nodes.forEach((p) => res.nodes.push({ ...p, x: p.x + dx, d: p.d + 1 }));
    s.edges.forEach((e) => res.edges.push({ px: e.px + dx, pd: e.pd + 1, cx: e.cx + dx, cd: e.cd + 1 }));
    s.stacks.forEach((st) => res.stacks.push({ lineX: st.lineX + dx, fromX: st.fromX + dx, fromD: st.fromD + 1, items: st.items.map((it) => ({ d: it.d + 1, left: it.left + dx })) }));
    res.edges.push({ px: 0, pd: 0, cx: dx, cd: 1 });
    merge(res.contour, s.contour, dx, 1);
  });
  return res;
}

export function layoutChart(roots, kids) {
  const r = layout({ id: "root", kind: "root" }, { ...kids, root: roots });
  const minX = Math.min(...Object.values(r.contour).map(([a]) => a), -180);
  const maxX = Math.max(...Object.values(r.contour).map(([, b]) => b), 180);
  const depth = Math.max(...r.nodes.map((p) => p.d));
  return { ...r, shift: -minX, width: maxX - minX, depth };
}
